var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FC4A4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6189 19.619C20.4082 18.8298 21.6873 18.8298 22.4761 19.619L32.0001 29.143L41.5241 19.619C42.3133 18.8298 43.5925 18.8298 44.3812 19.619C45.1705 20.4082 45.1705 21.6874 44.3812 22.4761L34.8572 32.0002L44.3812 41.5242C45.1705 42.3134 45.1705 43.5925 44.3812 44.3813C43.592 45.1705 42.3129 45.1701 41.5241 44.3813L32.0001 34.8573L22.4761 44.3813C21.6869 45.1701 20.4077 45.1701 19.6189 44.3813C18.8297 43.5921 18.8297 42.313 19.6189 41.5242L29.143 32.0002L19.6189 22.4761C18.8297 21.6869 18.8297 20.4078 19.6189 19.619V19.619Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ae65427a1d1a3ce80a6422a49bfe5b76.svg";
export { ForwardRef as ReactComponent };